module.exports = __webpack_public_path__ + "assets/img/service-d62cb1e2.png";